// src/layout/Sidebar.jsx
import { Layout, Menu } from "antd";
import { MenuFoldOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { getMenuItems } from "./menuItems";
import ProfileSection from "./ProfileSection";
import logo from "../assets/images/XynexAI_Logo.png";
import small_logo from "../assets/images/Small_XynexAI_Logo.png";

const { Sider } = Layout;

const Sidebar = ({ collapsed, setCollapsed, navigate, handleLogout, userInfo }) => {
  const location = useLocation();

  const selectedKey = useMemo(() => {
    if (location.pathname.startsWith("/dashboard/data-entry")) return "data-entry";
    if (location.pathname.startsWith("/dashboard/anamoly-detection")) return "anamoly-detection";
    if (location.pathname.startsWith("/dashboard/data-history")) return "data-history";
    if (location.pathname.startsWith("/dashboard/use-case")) return "use-case";
    return "home";
  }, [location.pathname]);

  const menuItems = getMenuItems(navigate, handleLogout);

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={84}
      breakpoint="lg"
      onBreakpoint={(broken) => setCollapsed(broken)}
      className="bg-[#1C1C1E] h-full border-r border-[#3A3A3C] !flex !flex-col"
      width={240}
    >
      {/* Header with logo and toggle */}
      <div className="h-24 flex items-center justify-center text-white text-lg font-semibold tracking-wide shrink-0">
        <div className="flex items-center gap-2">
          {collapsed ? null : (
            <span className="inline-block rounded-md m-4">
              <img src={logo} alt="XynexAi Logo" className="w-32 h-auto object-contain" />
            </span>
          )}
        </div>

        <button
          type="button"
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          onClick={() => setCollapsed(!collapsed)}
          className="inline-flex items-center justify-center w-14 h-9 rounded-md transition hover:bg-white/10"
        >
          {collapsed ? (
            <img
              src={small_logo}
              alt="XynexAI small logo"
               className="w-10 h-10 object-contain"
            />
          ) : (
            <MenuFoldOutlined className="text-white text-xl" />
          )}
        </button>
      </div>

      {/* Menu and push profile to bottom */}
      <div className="h-[88vh] flex flex-col">
        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[selectedKey]}
          items={menuItems}
          className="!bg-[#1C1C1E] text-base font-medium border-t border-slate-600 flex-1"
        />

        {/* Profile Section at Bottom */}
        <div>
          <ProfileSection collapsed={collapsed} userInfo={userInfo} handleLogout={handleLogout} />
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;